export const getBidListPath = ({
  jobId,
  isInterviewingTab,
}: {
  isInterviewingTab?: boolean;
  jobId: number;
}) => {
  return `/jobs/${jobId}/${isInterviewingTab ? "interviews" : "proposals"}/`;
};

export const getBidPath = ({
  jobId,
  isInterviewingTab,
  bidId,
}: {
  isInterviewingTab?: boolean;
  jobId: number;
  bidId: number;
}) => {
  return `${getBidListPath({ jobId, isInterviewingTab })}${bidId}`;
};
